export default __webpack_public_path__ + "250458be84f5a5642199205739e2b3fe.png";